import router from "../../router";
import authService from "../../services/auth";
import notiService from "../../services/notification";
import agencyService from "../../services/agency";
import conditionActivationService from "../../services/conditionActivation";
import generalSettingService from '../../services/generalSetting'
import { UserStoreInfoTagAction } from "../../constants/notification";
import { i18n } from '../../main'
const initialState = {
  areStylesLoaded: false,
  user: {},
  loggedIn: false,
  isNavigating: false,
  currentfrontendTech: null,
  generalSetting: null,
  isReturnLogin: false,
  loginErrorMessage:'',
  showConnectionBtn: false
};

const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    LOGIN_MANUALLY: (context, data) => {
      return new Promise((resolve, reject) => {
        authService.login(data).then((res) => {
          if (res.success) {
            context.commit("LOGIN_SUCCESS", res.data);
            context.commit("SET_TOKEN", res.data);
            context.commit("IS_NAVIGATING", true);
            const userBody = {
              email: res.data.email,
              firstName: res.data.firstName,
              lastName: res.data.lastName,
              pkAdv: res.data.pkAdv.toString()
            };
           
            // Get pk Agency to conditional
            let pkAgency = '';
            agencyService.getAgence().then((agenceRes) => {
              pkAgency = agenceRes.data.agency.pkAgency;
            }).finally(() => {
              const params = {
                email: encodeURIComponent(res.data.email),
              }
              pkAgency && (params.pkAgency = pkAgency)
              conditionActivationService.getCondition(params).then((conditionRes) => {
                if(conditionRes.success) {
                  localStorage.setItem("conditions", JSON.stringify(conditionRes.activation));
                  context.dispatch("REDIRECT_AFTER_LOGIN");
                  context.commit("SET_LOADING", false, { root: true });
                }
              });
            })
            
            notiService.getFrontendTechs().then((result)=> {
              const userStoreInfoBody = {
                pkUser: res.data.pkCrf.toString(),
                idPkUserType: 1,
                keyFrontendTech: null,
                tagAction: UserStoreInfoTagAction.LOGIN
              }
              const currTokenOS = 'ADV';
              if(result) {
              const webTech = result.frontendTechs.find(item =>  item.tokenMethod &&item.tokenMethod && item.tokenMethod.labelTokenMethod === currTokenOS && item.isWebApp).key;
              context.commit('UPDATE_CURRENT_FRONTEND_TECH', webTech);
              userStoreInfoBody.keyFrontendTech = webTech;
              notiService.updateStoreUserInfo(userStoreInfoBody);
              }

            })
            notiService.getNoticonfig().then((res)=> {
              localStorage.setItem("notificationConfig", JSON.stringify(res));

            })
            resolve(res);
            return;
          } else {
            context.commit("SET_ERROR_MESSAGE",res.message) ;
            reject(res);
          }
          context.commit("LOGIN_FAILED");
        }).catch((err) => {

          if(err && err.response && err.response.data && err.response.data.message) {
            const message = err.response.data.message;
            switch(err.response.data.message.code){
              case 'user_incarnation_not_found':
                context.commit("SET_ERROR_MESSAGE",i18n.t('user-not-found')) ;
              break;
              default:
                context.commit("SET_ERROR_MESSAGE",message.text||message) ;
            }
          }
        });
      })
    },
    SET_TOKEN_MANUALLY: (context, data) => {
      localStorage.setItem("token", data.token), delete data.token;
      localStorage.setItem("user", JSON.stringify(data));
      localStorage.setItem("isAuthenticated", true);
      //return;
    },
    REDIRECT_AFTER_LOGIN: (context) => {
      try {
        const isAuthenticated = Boolean(
          localStorage.getItem("isAuthenticated")
        );
        if (isAuthenticated) {
          const user = JSON.parse(localStorage.getItem("user"));
          const isExAdv = user.applicationStatus === 13 && user.isEmployee;

          let pathname = "";
          if (router.mode === "hash") {
            pathname = window.location.hash.replace("#", "");
          } else {
            pathname = window.location.pathname;
          }
          const uaerApplicationStatus = user.applicationStatus;
          const activeCompany = "vitalliance";

          const redirectRoute = context.rootGetters.redirectRouter;
          let route = redirectRoute ? redirectRoute.path : '';
          if (uaerApplicationStatus === 8 && (!route || !route.includes('employee'))) {
            route = "/employee/" + activeCompany + "/accueil-adv";
          } else if (uaerApplicationStatus !== 8 && (!route || !route.includes('candidate') || (!isExAdv && redirectRoute.meta.exAdv))) {
            route = "/candidate/" + activeCompany + "/profil-candidat";
          };
          router.push(route);
          context.dispatch("resetRedirectRouter", undefined, {root: true});
        }
      } catch {
        // context.dispatch("CLEAR_LOCALSTORAGE");
        context.dispatch("CLEAR_TOKEN");
        router.push("/public/default");
      }
    },
    CLEAR_LOCALSTORAGE: (context) => {
      localStorage.clear();
      router.push("/public/default");
    },
    CLEAR_TOKEN: (context) => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem('conditions');
    },
    CREATE_LAYOUT_INSTANCE: (context) => {
      const isAuthenticated = Boolean(localStorage.getItem("isAuthenticated"));
      if (isAuthenticated && !context.state.isNavigating) {
        context.dispatch("LOGIN_AUTOMATICALLY");
      }
    },
    CLEAR_DATA: (context)=> {
      context.state.areStylesLoaded = false
      context.state.user = {}
      context.state.loggedIn = false
      context.state.isNavigating = false
      context.dispatch("CLEAR_LOCALSTORAGE");
    },
    LOGIN_AUTOMATICALLY: (context) => {
      const user = JSON.parse(localStorage.getItem("user"));
      context.commit("LOGIN_SUCCESS", user);
    },
    DISCONNECT: (context) => {
      const userStoreInfoBody = {
        pkUser: context.state.user.pkCrf ? context.state.user.pkCrf.toString() : localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).pkCrf.toString(): null,
        idPkUserType: 1,
        keyFrontendTech: context.state.currentfrontendTech,
        tagAction: UserStoreInfoTagAction.LOGOUT
      }
      notiService.updateStoreUserInfo(userStoreInfoBody).then((res)=> {
        context.dispatch('CLEAR_DATA')
      }).catch((err)=> {
        context.dispatch('CLEAR_DATA')
      })
    },
    EXCHANGE_TOKEN: (context,data) => {
       
      return authService.exchangeToken(data).then((res) => {
        if (res.success) {
          const userStoreInfoBody = {
            pkUser: context.state.user.pkCrf.toString(),
            idPkUserType: 1,
            keyFrontendTech: context.state.currentfrontendTech,
            tagAction: UserStoreInfoTagAction.RENEWTOKEN
          }
          notiService.updateStoreUserInfo(userStoreInfoBody);
          context.commit("LOGIN_SUCCESS", res.data);
          context.commit("SET_TOKEN", res.data);
          return res.data;
        }
        return;
      }).catch((err)=> {
        store.dispatch("CLEAR_TOKEN");
        store.dispatch("DISCONNECT");          
        router.push('/public/default/connexion')
    });;
    },
    UPDATE_CURRENT_FRONTEND_TECH(store, currentfrontendTech) {
      store.commit('UPDATE_CURRENT_FRONTEND_TECH', currentfrontendTech)
    },
    
    GET_GENERAL_SETTING(store) {
      generalSettingService.getGeneralSetting().then((res) => {
        if(res.success && res.configuration) {
          store.commit('GET_GENERAL_SETTING', res.configuration)
        }
      })
    },
    SET_RETURN_LOGIN(store, isReturnLogin) {
      store.commit('SET_RETURN_LOGIN', isReturnLogin)
    },
    SET_SHOW_CONNECTION_BTN(store, showConnectionBtn) {
      store.commit('SET_SHOW_CONNECTION_BTN', showConnectionBtn)
    }
    
  },
  mutations: {
    LOGIN_SUCCESS: (state, user) => {
      state.user = user;
      state.loggedIn = true;
    },
    LOGIN_FAILED: (state) => {
      state.loggedIn = false;
    },
    SET_ERROR_MESSAGE: (state,errorMessage) => {
      state.loginErrorMessage = errorMessage;
   },
    SET_TOKEN: (state) => {
      localStorage.setItem("token", state.user.token), delete state.user.token;
      localStorage.setItem("user", JSON.stringify(state.user));
      localStorage.setItem("isAuthenticated", true);
    },
    STYLES_LOADED: (state, value) => {
      state.areStylesLoaded = value;
    },
    IS_NAVIGATING: (state, value) => {
      state.isNavigating = value;
    },
    UPDATE_CURRENT_FRONTEND_TECH: (state, currentfrontendTech) => {
      state.currentfrontendTech = currentfrontendTech;
    },
    GET_GENERAL_SETTING: (state, generalSetting) => {
      state.generalSetting = generalSetting;
    },
    SET_RETURN_LOGIN: (state, isReturnLogin) => {
      state.isReturnLogin = isReturnLogin;
    },
    SET_SHOW_CONNECTION_BTN: (state, showConnectionBtn) => {
      state.showConnectionBtn = showConnectionBtn;
    }
  },
  getters: {
    getUser: (state) => state.user,
    getCurrentFrontendTech: (state) => state.currentfrontendTech,
    generalSetting: (state)=>state.generalSetting,
    isReturnLogin: (state) => state.isReturnLogin,
    loginErrorMessage: (state) => state.loginErrorMessage,
    showConnectionBtn: (state) => state.showConnectionBtn
  },
};

export default auth;
